// The ./Router/index file is generated on build step so we ignore it to avoid linting errores
const nextRoutes = require('./Router/index'); // eslint-disable-line import/no-unresolved

const router = nextRoutes();

module.exports = router;



// WEBPACK FOOTER //
// ./app/router.js